import {IGeneralWithList} from "../../../../ifmsTypes";
import React, {MutableRefObject, useContext, useEffect} from "react";
import {useTypedFastStorage} from "../../../../hooks/useFastStorage";
import Fieldset from "../../../common/Fieldset";
import RadioButton from "../../../../ui/RadioButton";
import SecondaryButton from "../../../../ui/SecondaryButton";
import { BillListItem } from "../../../../fms.data/models/BillListItem";
import useReportViewer from "../../../../hooks/useReportViewer";
import { CheckReqCommonArgs } from "../../../../fms.report/args";
import { DocumentType } from "../../../../framework.core/DocumentType";
import ApplicationContext from "../../../../ApplicationContext";

interface PrintBillStorageKeys {
  modelStorage: string,
};
// 250716.inhyung issue#2561 PrintBill Detail���� BillListItem Ÿ�� ��ü.
interface PrintBillViewParams {
  id: string | undefined,
  //selectedElement: { id: number, billNo: string },
  selectedElement: BillListItem,
  invId: number | undefined,
  onPopupClose?: () => void
};

interface PrintBillLoadedDetailsViewParams {
  printBill: IGeneralWithList,
  printBillRef: MutableRefObject<IGeneralWithList | null>,
  setPrintBill: (x: Partial<IGeneralWithList>) => void,
  //selectedElement: { id: number, billNo: string },
  selectedElement: BillListItem,
  onPopupClose?: () => void,
  invId?: number,
};

function getPrintBillStorageKeys(): PrintBillStorageKeys {
  return {modelStorage: 'print-bill-report'}
}

function PrintBillImpl(params: PrintBillViewParams) {
  const {selectedElement, invId} = params;
  const {modelStorage} = getPrintBillStorageKeys();

  const [inStorage, setInStorage, removePrintBillFromStorage, printBillRef] = useTypedFastStorage<IGeneralWithList>(modelStorage, null);

  useEffect(() => {
      initialize();
      return () => {
        removePrintBillFromStorage()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function loadExisting() {
    return {
      printOption: 'C'
    }
  }

  async function initialize() {
    const data = await loadExisting();
    setInStorage({...data})
  }

  if (!inStorage) {
    return null;
  }

  return (
    <PrintBillInitializedImpl
      invId={invId}
      printBill={inStorage}
      printBillRef={printBillRef}
      setPrintBill={setInStorage}
      selectedElement={selectedElement}
      onPopupClose={params.onPopupClose}
    />
  );
}

function PrintBillInitializedImpl({
                                   invId,         
                                   printBill,
                                   printBillRef,
                                   setPrintBill,
                                   selectedElement,
                                   onPopupClose,
                                 }: PrintBillLoadedDetailsViewParams) {
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext)

  function onChange(change: Partial<IGeneralWithList>) {
    setPrintBill(change);
  }

  async function print(){
    const billNo = selectedElement.billNo ? selectedElement.billNo : selectedElement.invoiceNo;
    const id = invId ? invId.toString() : selectedElement.id.toString();
    let title = '';
    switch(printBill.printOption){
      case 'C': title = "Check Request (Detail)"; break;
      case 'D': title = "Check Request"; break;
      case 'M': title = "Messenger Slip"; break;
      case 'A': title = "Account Payable"; break;
    }
    title = title + ` [${billNo}]` 
    const payto = await appContext.api.getRList(id, 'T_APHD', 'F_Payto');
    const args = new CheckReqCommonArgs({
      docType: DocumentType.CheckReq,
      formCaption: title,
      subject: title,

      tbId: id,
      tbName: 'T_APHD',
      requestBy: appContext.user?.id??'',
      branch: appContext.suntekSettings?.company?.defaultBranch,
      reportType: printBill.printOption,
      toCompanyid: payto?.toString(),
    })
    viewReport(args, "", true);
  }

  return (
    <div className='report-popup'>
      <div className='report-row'>
        <Fieldset label='Print Option'>
          <div className='report-selectable-wrapper' style={{marginLeft: 98}}>
            <div className='report-selectable-col-2'><RadioButton group="printOption" reverse
                                                                                       label="Check Request (Detail)"
                                                                                       checked={printBill.printOption === 'C'}
                                                                                       onChecked={() => onChange({printOption: 'C'})}/>
            </div>
            <div className='report-selectable-col-2'><RadioButton group="printOption" reverse
                                                                                       label="Messenger Slip"
                                                                                       checked={printBill.printOption === 'M'}
                                                                                       onChecked={() => onChange({printOption: 'M'})}/>
            </div>
          </div>
          <div className='report-selectable-wrapper' style={{marginLeft: 98}}>
            <div className='report-selectable-col-2'><RadioButton group="printOption" reverse
                                                                  label="Check Request"
                                                                  checked={printBill.printOption === 'D'}
                                                                  onChecked={() => onChange({printOption: 'D'})}/>
            </div>
            <div className='report-selectable-col-2'><RadioButton group="printOption" reverse
                                                                  label="A/P Statement"
                                                                  checked={printBill.printOption === 'A'}
                                                                  onChecked={() => onChange({printOption: 'A'})}/>
            </div>
          </div>
        </Fieldset>
      </div>
      <div className='clearfix'/>
      <div className='report-footer'>
        <SecondaryButton
          name='printBill-detail-ok-button'
          size="regular"
          onClick={() => {
            print()
          }}>
          OK
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          name='printBill-detail-cancel-button'
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const PrintBillDetails = ({ 
                           invId,
                           onPopupClose,
                           selectedElement
                         }: { onPopupClose?: () => void, selectedElement?: any, invId?: number }) => {
  // const { id } = useParams<PrintBillViewParams>();

  /**
   * Implementation note:
   *   key is important in this case in order to force full List view rerender for different parameters.
   */

  return (
    <PrintBillImpl id={''} selectedElement={selectedElement} invId={invId} onPopupClose={onPopupClose} key={`printBill-details`}/>
  );
};
export default PrintBillDetails;